import { BaseSearchbarHistoryItem } from '../../../../redux/searchbar/types'
import { format } from '../../../../hooks/date'

export const getLocationPickerLabel = (location: string, locationPlaceholder: string) => {
    return !!location && location?.length > 0 ? location : locationPlaceholder
}

//TODO: change adults, children type to number | null

export const setHistoryItem = (
    location: string,
    arrival: Date | null,
    departure: Date | null,
    adults: number,
    children: number,
) => {
    const historyItem: BaseSearchbarHistoryItem = {
        arrival: arrival,
        departure: departure,
        search: location,
        children: children,
        adults: adults,
    }

    return historyItem
}

const _getSearchDate = (date: Date | null) => (date ? format(date, 'yyyy-MM-dd') : '')

export const getSearchUrl = (location: string, arrival: Date | null, departure: Date | null) => {
    const searchUrl = new URL('/events/suchergebnis', globalThis.location.origin)
    const urlSearchParams = new URLSearchParams(globalThis.location.search)
    if (location) {
        urlSearchParams.set('regionName', location.toLowerCase())
    }
    if (arrival) {
        urlSearchParams.set('fromDate', _getSearchDate(arrival))
    }
    if (departure) {
        urlSearchParams.set('toDate', _getSearchDate(departure))
    }
    searchUrl.search = urlSearchParams.toString()
    return searchUrl.href
}
